export default "__VITE_ASSET__pL$5OwNp__"